// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"bba86677","528":"d38e8dd0","664":"10d220a7","941":"1423c853"}[chunkId] + ".css";
};